/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */
import * as opentype from "App/lib/OpenType";
import RenderDocument from "App/render_document";

export default
class FontCache {

    private document: RenderDocument;
    private fontCacheItems: any[] = [];

    constructor(aDocument: RenderDocument) {
        this.document = aDocument;
    }

    public getFontCacheItem(aFontStyleProperties: any): any {
        for (let i = 0; i != this.fontCacheItems.length; i++) {
            let fontCacheItem = this.fontCacheItems[i];

            if (fontCacheItem.properties.family == aFontStyleProperties.family &&
                fontCacheItem.properties.style == aFontStyleProperties.style &&
                fontCacheItem.properties.size == aFontStyleProperties.size) {
                return fontCacheItem;
            }
        }

        return null;
    }

    public addFontToCache(aBuffer: ArrayBuffer, aFontStyleProperties: any) {
        if (this.getFontCacheItem(aFontStyleProperties)) return; // font is already in the cache

        let fontCacheItem: any = {
            properties: aFontStyleProperties,
            fontObject: null
        };

        fontCacheItem.fontObject = opentype.parse(aBuffer);

        this.fontCacheItems.push(fontCacheItem);
    }
}
